<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thêm mới cấu hình yêu cầu báo cáo định kỳ</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Tên cấu hình:"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left"
                              label-class="required">
                  <b-col md="6 no-padding">
                    <b-form-input type="text" v-if="editing"
                                  v-model="$v.reportRequest.name.$model"
                                  :state="$v.reportRequest.name.$dirty? !$v.reportRequest.name.$error : null"></b-form-input>
                    <b-form-invalid-feedback>
                      Tên cấu hình không được để trống
                    </b-form-invalid-feedback>
                    <label class="col-form-label" v-if="!editing">{{ reportRequest.name }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Nguồn báo cáo:"
                              title="Nguồn báo cáo (3 hệ thống QLTSC/CTNS/HTGTĐB)"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left"
                              label-class="required">
                  <b-col md="6 no-padding">
                    <b-form-input type="text" style="display: none"
                                  v-model="$v.reportRequest.syncDataSourceId.$model"
                                  :state="$v.reportRequest.syncDataSourceId.$dirty? !$v.reportRequest.syncDataSourceId.$error : null"></b-form-input>
                    <select2 placeholder="--- Chọn nguồn báo cáo ---" class="col-md-6"
                             v-if="listSyncDataSources.length > 0 && editing"
                             v-model="$v.reportRequest.syncDataSourceId.$model"
                             :options="listSyncDataSources"></select2>
                    <b-form-invalid-feedback>
                      Nguồn báo cáo không được để trống
                    </b-form-invalid-feedback>
                    <label class="col-form-label" v-if="!editing">{{ reportRequest.syncDataSourceName }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Loại báo cáo:"
                              :horizontal="true"
                              label-cols-md="3"
                              label-align="left"
                              label-class="required">
                  <b-col md="6 no-padding">
                    <b-form-input type="text" class="col-md-6" style="display:none;"
                                  v-model="$v.reportRequest.reportTypeId.$model"
                                  :state="$v.reportRequest.reportTypeId.$dirty? !$v.reportRequest.reportTypeId.$error : null">
                    </b-form-input>
                    <treeselect v-model="reportRequest.reportTypeId" v-if="editing"
                                placeholder="--- Chọn loại báo cáo ---"
                                :disable-branch-nodes="true"
                                :show-count="true"
                                :options="listReports"
                                :disabled="listReports.length == 0" />
                    <b-form-invalid-feedback>
                      Vui lòng chọn loại báo cáo
                    </b-form-invalid-feedback>
                    <label class="col-form-label" v-if="!editing">{{ $store.getters.getReportSyncTypeName(reportRequest.reportTypeId) }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Đơn vị xuất báo cáo:"
                              :horizontal="true"
                              label-cols-md="3"
                              label-align="left">
                  <b-col md="6 no-padding">
                    <top-level-unit v-model="reportRequest.listUnitIds" allowClear="true" multiple v-if="editing"></top-level-unit>
                    <label class="col-form-label" v-if="!editing">{{ reportRequest.listUnitNames.join(', ') }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="URL/Login"
                              :horizontal="true"
                              label-cols-md="3"
                              label-align="left"
                              label-class="required">
                  <b-form-input type="text" class="col-md-6" v-if="editing"
                                disabled
                                v-model="$v.reportRequest.requestUrl.$model"
                                :state="$v.reportRequest.requestUrl.$dirty? !$v.reportRequest.requestUrl.$error : null">
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Vui lòng nhập đường dẫn
                  </b-form-invalid-feedback>
                  <label class="col-form-label" v-if="!editing">{{ reportRequest.requestUrl }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Tần suất thực hiện:"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left"
                              label-class="required">
                  <b-form-radio-group v-model="frequencyType" style="padding-bottom: 7px" v-if="editing"
                                      name="radio-sub-component">
                    <b-form-radio value="daily">Hàng ngày</b-form-radio>
                    <b-form-radio value="monthly">Hàng tháng</b-form-radio>
                    <b-form-radio value="yearly">Hàng năm</b-form-radio>
                    <b-form-radio value="cron">Nâng cao</b-form-radio>
                  </b-form-radio-group>
                  <label class="col-form-label" v-if="!editing">{{ frequencyCronTranslation }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <template v-if="editing">
              <b-row v-if="frequencyType == 'monthly'">
                <b-col offset-md="2">
                  <b-form-group label="Vào ngày:"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left"
                                label-class="required">
                    <b-col md="6 no-padding">
                      <select2 :options="daysInMonth" v-model="frequencyDayInMonth"></select2>
                    </b-col>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="frequencyType == 'yearly'">
                <b-col offset-md="2">
                  <b-form-group label="Vào ngày:"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left"
                                label-class="required">
                    <b-col md="6 no-padding">
                      <b-form-input type="text"
                                    v-model="frequencyDayInYear"
                                    @input="validateFrequencyDayInYearFormat"
                                    :state="$v.frequencyDayInYearFormat.$dirty? !$v.frequencyDayInYearFormat.$error : null"
                                    placeholder="dd/MM"></b-form-input>
                      <b-form-invalid-feedback v-if="$v.frequencyDayInYearFormat.$error">
                        Vui lòng nhập đúng định dạng (dd/MM)
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="frequencyType == 'cron'">
                <b-col offset-md="2">
                  <b-form-group label="Đinh dạng cron:"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left"
                                label-class="required">
                    <b-input-group :prepend="cronHourPrefix" class="col-md-6 no-padding">
                      <b-form-input type="text"
                                    v-model="$v.frequencyCron.$model"
                                    :state="($v.frequencyCron.$dirty ? !$v.frequencyCron.$error : null) && ($v.frequencyCronTranslation.$dirty ? !$v.frequencyCronTranslation.$error : null)">
                      </b-form-input>
                    </b-input-group>
                    <div class="invalid-feedback" style="display: block;" v-if="$v.frequencyCron.$error"> Tần suất không được để trống! </div>
                    <div class="invalid-feedback" style="display: block;" v-if="!$v.frequencyCron.$error && $v.frequencyCronTranslation.$error"> Định dạng chưa chuẩn! </div>
                    <small class="col-md-6 no-padding form-text text-muted" style="color: green !important;"> {{ frequencyCronTranslation }} </small>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Loại báo cáo theo thời kỳ:"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left">
                  <b-col md="6 no-padding">
                    <label class="col-form-label">{{ $store.getters.getPeriodTypes(reportRequest.periodType) }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="2">
                <b-form-group label="User dùng để login:"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left"
                              label-class="required">
                  <b-col md="6 no-padding">
                    <b-form-input type="text" style="display: none"
                                  v-model="$v.reportRequest.requestUserId.$model"
                                  :state="$v.reportRequest.requestUserId.$dirty? !$v.reportRequest.requestUserId.$error : null"></b-form-input>
                    <select2 placeholder="--- Chọn người dùng ---"
                             v-if="listRequestUsers.length > 0 && editing"
                             v-model="$v.reportRequest.requestUserId.$model"
                             disabled
                             readonly
                             :options="listRequestUsers" allowClear></select2>
                    <b-form-invalid-feedback>
                      User không được để trống
                    </b-form-invalid-feedback>
                    <label class="col-form-label" v-if="!editing">{{ reportRequest.reportRequestLoginUserUserName }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Tùy chọn năm xuất báo cáo:"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left">
                  <b-col md="6 no-padding">
                    <select2 style="width:100%" v-if="listPeriodTypeReportYear.length > 0 && editing" :options="listPeriodTypeReportYear"
                             v-model="reportRequest.periodTypeReportYear"></select2>
                    <label class="col-form-label" v-if="!editing">{{ $store.getters.getPeriodTypeReportYears(reportRequest.periodTypeReportYear) }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Dành cho báo cáo theo ngày -->
            <b-row v-if="reportRequest.periodType == 1">
              <b-col offset-md="2">
                <b-form-group label="Ngày báo cáo (dd/MM):"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left"
                              label-class="required">
                  <b-col md="6 no-padding">
                    <b-form-input type="text" v-if="editing"
                                  v-model="$v.reportRequest.periodEndTime.$model"
                                  @input="validatePeriodEndTimeFormat"
                                  :state="($v.reportRequest.periodEndTime.$dirty? !$v.reportRequest.periodEndTime.$error : null) && ($v.periodEndTimeFormat.$dirty? !$v.periodEndTimeFormat.$error : null)"
                                  placeholder="dd/MM"></b-form-input>
                    <b-form-invalid-feedback v-if="$v.reportRequest.periodEndTime.$error">
                      Ngày báo cáo không được để trống
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.reportRequest.periodEndTime.$error && $v.periodEndTimeFormat.$error">
                      Vui lòng nhập đúng định dạng (dd/MM)
                    </b-form-invalid-feedback>
                    <label class="col-form-label" v-if="!editing">{{ reportRequest.periodEndTime }}</label>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Dành cho báo cáo theo khoảng thời gian -->
            <template v-if="reportRequest.periodType == 2">
              <b-row>
                <b-col offset-md="2">
                  <b-form-group label="Thời điểm bắt đầu báo cáo (dd/MM):"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left"
                                label-class="required">
                    <b-col md="6 no-padding">
                      <b-form-input type="text" v-if="editing"
                                    v-model="$v.reportRequest.periodStartTime.$model"
                                    @input="validatePeriodStartTimeFormat"
                                    :state="($v.reportRequest.periodStartTime.$dirty? !$v.reportRequest.periodStartTime.$error : null) && ($v.periodStartTimeFormat.$dirty? !$v.periodStartTimeFormat.$error : null)"
                                    placeholder="dd/MM"></b-form-input>
                      <b-form-invalid-feedback v-if="$v.reportRequest.periodStartTime.$error">
                        Thời điểm bắt đầu báo cáo không được để trống
                      </b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.reportRequest.periodStartTime.$error && $v.periodStartTimeFormat.$error">
                        Vui lòng nhập đúng định dạng (dd/MM)
                      </b-form-invalid-feedback>
                      <label class="col-form-label" v-if="!editing">{{ reportRequest.periodStartTime }}</label>
                    </b-col>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col offset-md="2">
                  <b-form-group label="Thời điểm kết thúc báo cáo (dd/MM):"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left">
                    <b-col md="6 no-padding">
                      <b-form-input type="text" v-if="editing"
                                    v-model="$v.reportRequest.periodEndTime.$model"
                                    @input="validatePeriodEndTimeFormat"
                                    :state="($v.reportRequest.periodEndTime.$dirty? !$v.reportRequest.periodEndTime.$error : null) && ($v.periodEndTimeFormat.$dirty? !$v.periodEndTimeFormat.$error : null)"
                                    placeholder="dd/MM"></b-form-input>
                      <b-form-invalid-feedback v-if="$v.reportRequest.periodEndTime.$error">
                        Thời điểm kết thúc báo cáo không được để trống
                      </b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="$v.periodEndTimeFormat.$error">
                        Vui lòng nhập đúng định dạng (dd/MM)
                      </b-form-invalid-feedback>
                      <label class="col-form-label" v-if="!editing">{{ reportRequest.periodEndTime }}</label>
                    </b-col>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <template v-if="!editing">
              <b-row>
                <b-col offset-md="2">
                  <b-form-group label="Lần thực thi tiếp theo:"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left">
                    <b-col md="6 no-padding">
                      <label class="col-form-label">{{ reportRequest.nextExecutionTime | formatTime }}</label>
                    </b-col>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col offset-md="2">
                  <b-form-group label="Lần thực thi gần nhất:"
                                :label-cols="3"
                                :horizontal="true"
                                label-align="left">
                    <b-col md="6 no-padding">
                      <label class="col-form-label">{{ reportRequest.lastExecutionTime | formatTime }}</label>
                    </b-col>
                  </b-form-group>
                </b-col>
              </b-row>
              <template v-if="reportRequest.lastExecutionTime">
                <b-row>
                  <b-col offset-md="2">
                    <b-form-group label="Kết quả:"
                                  :label-cols="3"
                                  :horizontal="true"
                                  label-align="left">
                      <b-col md="6 no-padding">
                        <label class="col-form-label">{{ reportRequest.lastExecutionStatus ? 'Thành công' : 'Thất bại' }}</label>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="!reportRequest.lastExecutionStatus">
                  <b-col offset-md="2">
                    <b-form-group label="Thông tin lỗi:"
                                  :label-cols="3"
                                  :horizontal="true"
                                  label-align="left">
                      <b-col md="6 no-padding">
                        <label class="col-form-label">{{ reportRequest.lastExecutionMessage }}</label>
                      </b-col>
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>
            </template>

            <b-row>
              <b-col offset-md="2">
                <b-form-group label="Trạng thái hoạt động:"
                              :label-cols="3"
                              :horizontal="true"
                              label-align="left"
                              label-class="required">
                  <b-col md="6 no-padding">
                    <b-checkbox :disabled="!editing" v-model="reportRequest.isActive"></b-checkbox>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="isBTCUser">
              <b-col offset-md="2">
                <b-form-group label="" :label-cols="3">
                  <b-button type="submit" variant="primary" v-if="editing"> Lưu</b-button>
                  <b-button type="button" variant="secondary" @click="back"> Quay lại</b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { mixins } from '@/shared/mixins'
  import { required, requiredIf } from 'vuelidate/lib/validators'
  import cronstrue from 'cronstrue';
  import '@/utils/cron_locale_vi';

  export default {
    name: 'DetailReportRequest',
    mixins: [mixins],
    data() {
      return {
        editing: this.$route.meta.editing,
        reportRequest: {
          name: null,
          requestUrl: null,
          requestFrequency: null,
          requestUserId: null,
          periodType: 1,
          periodStartTime: null,
          periodEndTime: null,
          reportTypeId: null,
          syncDataSourceId: null,
          listUnitIds: [],
          periodTypeReportYear: 1,
          listUnitNames: []
        },
        listRequestUsers: [],
        units: [],
        listReports: [],
        frequencyType: 'monthly',
        frequencyDayInMonth: 1,
        frequencyDayInYear: '01/01',
        daysInMonth: Array.from({ length: 31 }, (x, i) => i + 1),
        frequencyDayInYearFormat: 'ok',
        periodStartTimeFormat: 'ok',
        periodEndTimeFormat: 'ok',
        cronHourPrefix: '0 1 ',
        frequencyCron: '1 1 *',
        frequencyCronTranslation: ''
      }
    },
    computed: {
      ...mapState({
        listRequestUserFulls: (state, getters) => getters.getReportRequestLoginUsers(),
        listSyncDataSources: (state, getters) => getters.getSyncDataSources,
        listPeriodType: (state, getters) => state.common.listPeriodType,
        listPeriodTypeReportYear: (state, getters) => state.common.listPeriodTypeReportYear,
      }),
      id() {
        return this.$route.params.id;
      },
    },
    created() {
      this.units = this.$store.state.common.topLevelUnits;
      this.loadReportRequestDetail();
      this.checkValidationCron();
    },
    validations: {

      reportRequest: {
        name: { required },
        reportTypeId: { required },
        requestUrl: { required },
        requestUserId: { required },
        syncDataSourceId: { required },
        periodStartTime: {
          required: requiredIf(function () {
            return this.reportRequest.periodType == 2;
          })
        },
        periodEndTime: {
          required: requiredIf(function () {
            return this.reportRequest.periodType == 1 || this.reportRequest.periodType == 2;
          })
        }
      },
      frequencyCron: { required },
      frequencyCronTranslation: {
        required: requiredIf(function () {
          return this.frequencyType == 'cron';
        })
      },
      frequencyDayInYearFormat: {
        required: requiredIf(function () {
          return this.frequencyType == 'yearly';
        })
      },
      periodStartTimeFormat: { required },
      periodEndTimeFormat: { required },
    },
    watch: {
      'reportRequest.syncDataSourceId'(newVal) {
        if (newVal) {
          var vm = this;

          let data = [...vm.listRequestUserFulls];
          vm.listRequestUsers = data.filter((x) => x.syncDataSourceId == newVal);

          vm.$nextTick(() => {
            if (vm.listRequestUsers.length > 0) {
              vm.reportRequest.requestUserId = vm.listRequestUsers[0].id;
            }
          })

          var syncDataSource = vm.listSyncDataSources.find((x) => x.id == newVal);
          if (syncDataSource) {
            vm.reportRequest.requestUrl = syncDataSource.reportRequestUrl;
          }

          this.loadReportTypeBySyncDataSource(newVal);
        }
      },
      frequencyCron() {
        this.checkValidationCron();
      }
    },
    methods: {
      back() {
        this.$router.push({ path: '../' });
      },
      save() {
        this.$v.$touch();
        var vm = this;
        switch (vm.frequencyType) {
          case 'daily': this.frequencyCron = "* * *"; break;
          case 'monthly': this.setMonthlyCron(); break;
          case 'yearly': this.validateFrequencyDayInYearFormat(); break;
        }

        switch (vm.reportRequest.periodType) {
          case 1: this.reportRequest.periodStartTime = ''; break;
          case 3: this.reportRequest.periodStartTime = ''; this.reportRequest.periodEndTime = ''; break;
        }

        if (this.reportRequest.listUnitIds.length === 0) {
          this.reportRequest.listUnitIds = [...new Set(this.units.map(x => x.id))];
        }
        if (!vm.$v.$invalid) {
          vm.$services.put(`system-parameters/report-request-parameters/${vm.reportRequest.id}`, vm.reportRequest).done((id) => {
            vm.$toastr.s('Cập nhật cấu hình yêu cầu báo cáo thành công');
            vm.back();
          });
        }
      },
      checkValidationCron() {
        var vm = this;
        var cronExpression = `${this.cronHourPrefix}${this.frequencyCron}`;

        try {
          vm.frequencyCronTranslation = this.normalizeCronTransalation(cronstrue.toString(cronExpression, { locale: 'vi' }));
          vm.reportRequest.requestFrequency = cronExpression;
        } catch (ex) {
          vm.frequencyCronTranslation = '';
          vm.reportRequest.requestFrequency = '';
        }
      },
      normalizeCronTransalation(translation) {
        return translation.replace('của tháng, chỉ tính trong Tháng', 'của Tháng');
      },
      loadReportTypeBySyncDataSource(syncDataSourceId) {
        if (syncDataSourceId) {
          var vm = this;
          vm.$services.get(`lookup/report-types/${syncDataSourceId}/list`).done((response) => {
            vm.listReports = vm.$store.getters.getTreeReportByReportTypes(response);
          });
        }
      },
      isValidDayInYear(value) {
        if (!value) return false;
        if (typeof (value) != 'string') return false;

        var parts = value.split('/');

        if (parts.length != 2) return false;

        var day = parseInt(parts[0]);
        var month = parseInt(parts[1]);

        if (isNaN(day) || day < 1 || day > 31) return false;
        if (isNaN(month) || month < 1 || month > 12) return false;

        return true;
      },
      validateFrequencyDayInYearFormat() {
        this.$v.frequencyDayInYearFormat.$touch();
        if (this.isValidDayInYear(this.frequencyDayInYear)) {
          this.frequencyDayInYearFormat = 'ok';
          var day = parseInt(this.frequencyDayInYear.split('/')[0]);
          var month = parseInt(this.frequencyDayInYear.split('/')[1]);
          this.frequencyCron = `${day} ${month} *`;
        } else {
          this.frequencyDayInYearFormat = '';
        }
      },
      validatePeriodStartTimeFormat() {
        this.$v.periodStartTimeFormat.$touch();
        this.periodStartTimeFormat = this.isValidDayInYear(this.reportRequest.periodStartTime) ? 'ok' : '';
      },
      validatePeriodEndTimeFormat() {
        this.$v.periodEndTimeFormat.$touch();
        this.periodEndTimeFormat = this.isValidDayInYear(this.reportRequest.periodEndTime) ? 'ok' : '';
      },
      setMonthlyCron() {
        this.frequencyCron = `${this.frequencyDayInMonth} * *`;
      },
      loadReportRequestDetail() {
        var vm = this;
        if (vm.id) {
          vm.$services.get(`system-parameters/report-request-parameters/${vm.id}`, null).done((response) => {
            var requestUrl = response.requestUrl;
            vm.reportRequest = response;
            vm.frequencyCron = response.requestFrequency.substr(4);
            vm.setFrequencyType(vm.frequencyCron);

            vm.$nextTick(() => {
              vm.reportRequest.requestUrl = requestUrl;
            });
          });
        }
      },
      setFrequencyType(frequencyCron) {
        var parts = frequencyCron.split(' ');
        if (parts.length == 3) {
          var dayInMonth = parts[0];
          var monthInYear = parts[1];
          var dayOfWeek = parts[2];

          if (dayInMonth == "*" && monthInYear == "*" && dayOfWeek == "*") {
            this.frequencyType = "daily";
          } else if (dayInMonth != "*" && monthInYear == "*" && dayOfWeek == "*") {
            this.frequencyType = "monthly";
            this.frequencyDayInMonth = parseInt(dayInMonth);
          } else if (dayInMonth != "*" && monthInYear != "*" && dayOfWeek == "*") {
            this.frequencyType = "yearly";
            this.frequencyDayInYear = `${dayInMonth.padStart(2, '0')}/${monthInYear.padStart(2, '0')}`;
          } else {
            this.frequencyType = "cron";
          }
        } else {
          this.frequencyType = "cron";
        }
      }
    }
  }

</script>
<style scoped>
</style>
